export enum OrientationEnum {
  landscape = 'landscape',
  portrait = 'portrait',
  row = 'row',
  column = 'column'
}
